export const getDateValue = (value) => {
    if (value instanceof Date)
        return value;
    if (typeof value === "string")
        return new Date(value);
    return null;
};
